import standardCarousel from "@libs/standard-carousel";
import { docReady, qsa } from "@libs/helpers";
import { media } from "@parts/media";

const getData = (el, attr) => {
    let yesNo = el.getAttribute(attr);

    if (yesNo === 'false') {
        yesNo = false;
    }

    if (yesNo === 'true') {
        yesNo = true;
    }

    return yesNo;
};

docReady( () => {

	const initFns = [];

    qsa('[data-carousel]', el => {

		let flkty;
		
		const breakpoint = getData(el, 'data-breakpoint');
		// Scrape flickity options from data attr.
		const dataOptionsText = getData(el, 'data-config' );
		let options = false;

		if ( dataOptionsText ) {
			options = JSON.parse( dataOptionsText );
		}
		
		const init = () => {
			
			if ( flkty && !breakpoint ) {
				// Flkty already initialised, no breakpoint, no need to restore, just return.
				return;
			}
			
			if ( flkty ) {
				// if init is happening again, kill a flkty
				// to rebuild. 
				flkty.destroy();
			}
			
			if ( breakpoint && !media.matches( breakpoint ) ) {
				// breakpoint doesn't match, and since flickity was destroyed
				// this means we can exit with no flickity initialised.
				return;
			}
			
			// Flickity is now initialised with the options.
			flkty = standardCarousel(el, '[data-slide]', options);
			const counterDiv = el.querySelector('[data-counter]');

			if ( counterDiv ) {

				const update = () => {
					counterDiv.innerText = `${flkty.selectedIndex + 1} / ${flkty.cells.length}`;
				};

				update();
				flkty.on('select', update);
			}
		}

		// Store all our initialisation functions...
        initFns.push( init );
		
	});
	
	// ...to be executed in one go...
	const initAll = () => {
		initFns.forEach( fn => fn() );
	};

	// ...once on load
	initAll();	

	// ...and altogether on a window resize.
	window.addEventListener('resize', initAll );
});